<template>
  <section id="agency" ref="agencyContent">
    <PageTitle :title="$t('hospitality.apartment.title')" :breadcrumbs="breadcrumbs"></PageTitle>
    
    <div class="wrapper wrapper-content animated fadeInRight">

      <Header></Header>

      <div class="row" v-if="selectedAgency">
        <div class="col">
          <ListApartments></ListApartments>
        </div>
      </div>

    </div>
  </section>
</template>


<script lang="ts">
import { Component } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';

import PageTitle from '@root/src/client/components/panels/PageTitle.vue';
import { enableIbox, disableIbox} from '@root/src/client/theme/inspinia-jquery'; 

import { useAgencyAdmin } from '../../composables/useAgencyAdmin';

import Header from '../panels/Header.vue';

import ListApartments from '../panels/apartments/ListApartments.vue';

@Component({
  components: {
    PageTitle,
    ListApartments,
    Header
  }
})
export default class Apartments extends mixins(GenericPage) {

  setup(props:any, context:any) {
    const { agencies, selectedAgency } = useAgencyAdmin(props, context);
    return { agencies, selectedAgency }
  }

  get breadcrumbs() {
    return [{
      label: this.$t('home.dashboard')
    },
    {
      label: this.$t('hospitality.title')
    }]
  }

  mounted() {
    enableIbox(this.$refs.agencyContent as HTMLElement);
  }

  beforeDestroy() {
    disableIbox(this.$refs.agencyContent as HTMLElement);
  }

}
</script>